/*
Spanish resource file. Mirror of fr.ts — same nested key shape.
First-pass translations; review for register / Latin-America vs.
Spain idiom before shipping to a real Spanish-speaking deployment.
*/

export const es =
{
	common:
	{
		loading:			"Cargando…",
		error_network:		"Error de red.",
		error_loading:		"Error de carga: {{message}}",
		never:				"nunca",
		none:				"ninguno",
		dash:				"—",
		yes:				"Sí",
		no:					"No",
		cancel:				"Cancelar",
		confirm:			"Confirmar",
		save:				"Guardar",
		update:				"Actualizar",
		updating:			"Actualizando…",
		send:				"Enviar",
		sending:			"Enviando…",
		clear:				"Limpiar",
		prev:				"← Anterior",
		next:				"Siguiente →",
		page_of:			"Página {{page}} de {{total}}",
		rows_per_page:		"Filas por página",
		page_size_label:	"Número de filas por página",
		download:			"Descargar",
		downloading:		"Descargando…",
		retry:				"Reintentar",
		error_state_title:	"Ha ocurrido un error",
		from:				"De",
		to:					"A",
	},

	nav:
	{
		app_name:			"SpirApps",
		my_cards:			"Mis tarjetas",
		shared_with_me:		"Compartidas conmigo",
		my_account:			"Mi cuenta",
		statistics:			"Estadísticas",
		users:				"Usuarios",
		audit:				"Auditoría",
		logout:				"Cerrar sesión",
		copyright:			"© Spirtech 2026",
	},

	auth:
	{
		login_title:					"SpirApps",
		login_subtitle_passwordless:	"Introduzca su correo electrónico; le enviaremos un código de acceso de 6 dígitos.",
		email_label:					"Correo electrónico",
		code_label:						"Código de 6 dígitos",
		send_code_submit:				"Enviar código",
		login_submit:					"Iniciar sesión",
		login_progress:					"Iniciando sesión…",
		code_sent_info:					"Si existe una cuenta para este correo, acabamos de enviarle un código. Revise su bandeja de entrada (y la carpeta de spam). El código es válido durante 1 hora.",
		code_resent_info:				"Se le ha enviado un nuevo código. El código anterior ya no es válido.",
		code_step_subtitle:				"Introduzca el código enviado a {{email}}.",
		change_email_link:				"Usar otro correo",
		resend_code_link:				"Reenviar código",

		err_invalid_credentials:	"Código incorrecto o caducado.",
		err_account_disabled:		"Cuenta desactivada. Contacte al administrador.",
		err_missing_field:			"Por favor complete todos los campos.",
		err_rate_limited:			"Demasiados intentos. Inténtelo de nuevo en unos minutos.",
		err_default:				"Error al iniciar sesión. Inténtelo de nuevo.",
		session_expired_banner:		"Sesión expirada. Inicie sesión nuevamente.",
	},

	cards:
	{
		title:					"Mis tarjetas",
		title_count:			"Mis tarjetas ({{total}})",
		no_cards:				"Aún no se ha subido ninguna tarjeta.",
		no_cards_with_filters:	"Ninguna tarjeta coincide con los filtros.",
		col_serial:				"Número de serie",
		col_type:				"Tipo",
		col_model:				"Modelo",
		col_folder:				"Carpeta",
		col_read_on:			"Leída el",
		filter_serial:			"Número de serie…",
		filter_type:			"Tipo (p. ej. CALYPSO_PRIME)",
		filter_type_all:		"Todos los tipos",
		filter_model:			"Modelo (p. ej. INTERCODE_2_2)",
		filter_model_all:		"Todos los modelos",
		filter_folder:			"Carpeta (prefijo)",
		filter_date_min:		"Fecha de lectura mín.",
		filter_date_max:		"Fecha de lectura máx.",
		delete_tooltip:			"Eliminar",
		delete_aria:			"Eliminar la tarjeta {{serial}}",
		delete_dialog_title:	"¿Eliminar la tarjeta?",
		delete_dialog_body:		"Esta acción es irreversible.",
		delete_dialog_button:	"Eliminar",
		export_csv:				"Exportar CSV",
		export_xlsx:			"Exportar Excel",
	},

	compare:
	{
		title:				"Comparación de dos tarjetas",
		section_title:		"Comparar esta tarjeta",
		button:				"Comparar con…",
		picker_title:		"Elija la tarjeta a comparar",
		picker_search:		"Número de serie…",
		picker_empty:		"No hay otra tarjeta disponible para comparar.",
		picker_cancel:		"Cancelar",
		card_type:			"Tipo",
		data_model:			"Modelo",
		read_date:			"Leída el",
		folder:				"Carpeta",
		section_select:		"SELECT",
		section_sv:			"SV",
		section_environment:"Entorno",
		section_contracts:	"Contratos",
		section_events:		"Eventos",
		field:				"Campo",
		value_a:			"Valor A",
		value_b:			"Valor B",
		missing_ids:		"Enlace de comparación incompleto (faltan parámetros a / b).",
	},

	card_detail:
	{
		back_to_list:				"← Volver a la lista",
		read_on:					"{{type}} — {{model}} — leída el {{date}}",
		downloads_title:			"Descargas",
		downloads_derived:			"(derivado)",
		downloads_error_status:		"Error {{status}}: {{message}}",
		downloads_error_network:	"Error de red durante la descarga.",
		parts_bundle_title:			"Partes del paquete",
		parts_col_name:				"Nombre",
		parts_col_type:				"Tipo",
		parts_col_file:				"Archivo",
		parts_col_received:			"Recibido el",
		raw_metadata_title:			"Metadatos en bruto",
		share_title:				"Compartir",
		share_email_placeholder:	"Correo del destinatario",
		share_message_placeholder:	"Mensaje (opcional)",
		share_submit:				"Compartir",
		share_progress:				"Compartiendo…",
		shares_col_recipient:		"Destinatario",
		shares_col_shared_on:		"Compartido el",
		shares_col_viewed:			"Visto",
		shares_col_message:			"Mensaje",
		no_active_shares:			"No hay compartidos activos para esta tarjeta.",
		revoke_button:				"Revocar",
		revoke_progress:			"Revocando…",
		revoke_dialog_title:		"¿Revocar el compartido?",
		revoke_dialog_body:			"El destinatario perderá inmediatamente el acceso a esta tarjeta.",
		revoke_error:				"Error durante la revocación.",
		share_err_missing_field:	"Faltan campos obligatorios o el correo es inválido.",
		share_err_recipient:		"Ningún usuario coincide con ese correo.",
		share_err_self:				"No puede compartir consigo mismo.",
		share_err_forbidden:		"Acceso denegado.",
		share_err_default:			"Error ({{status}}).",
	},

	profile:
	{
		title:				"Mi cuenta",
		field_email:		"Correo electrónico",
		field_role:			"Rol",
		field_created_on:	"Cuenta creada el",
		field_last_login:	"Último inicio de sesión",
		field_last_lockout:	"Último bloqueo automático",
		lockout_warning:	"Si este bloqueo no fue suyo, contacte al administrador.",
		email_form_title:	"Cambiar mi correo",
		new_email_label:	"Nueva dirección",
		email_same_as_current:	"La nueva dirección es idéntica a la actual.",
		email_updated:		"Correo actualizado.",
		err_email_taken:	"Esta dirección ya está siendo usada por otra cuenta.",
		err_missing_field:	"Faltan campos obligatorios o son inválidos.",
		err_unauthenticated:	"Sesión expirada. Inicie sesión nuevamente.",
		err_default:		"Error ({{status}}).",
	},

	shared:
	{
		title_count:			"Compartidas conmigo ({{total}})",
		no_shares:				"Nadie le ha compartido una tarjeta todavía.",
		col_serial:				"Número de serie",
		col_shared_by:			"Compartido por",
		col_received_on:		"Recibido el",
		col_type:				"Tipo",
		col_model:				"Modelo",
		col_message:			"Mensaje",
		new_badge:				"Nuevo",
	},

	admin_users:
	{
		title_count:				"Usuarios ({{total}})",
		search_placeholder:			"Buscar por correo…",
		col_email:					"Correo electrónico",
		col_role:					"Rol",
		col_cards:					"Tarjetas",
		col_created:				"Creado",
		col_status:					"Estado",
		you:						"(usted)",
		status_active:				"activo",
		status_disabled:			"desactivado",
		status_locked:				"bloqueado",
		locked_until_tooltip:		"Bloqueado hasta {{date}} {{time}}",
		btn_promote:				"→ Admin",
		btn_demote:					"→ Usuario",
		btn_disable:				"Desactivar",
		btn_reactivate:				"Reactivar",
		btn_unlock:					"Desbloquear",
		btn_delete:					"Eliminar",
		btn_resend_welcome:			"Reenviar invitación",
		welcome_resent_ok:			"Correo de invitación reenviado a {{email}}.",
		welcome_resent_err:			"No se pudo enviar la invitación a {{email}}.",
		delete_dialog_title:		"¿Eliminar al usuario?",
		delete_dialog_body:			"Todas las tarjetas de este usuario también serán eliminadas. Esta acción es irreversible.",
		create_title:				"Crear un usuario",
		create_email:				"Correo electrónico",
		create_role:				"Rol",
		create_submit:				"Crear",
		create_progress:			"Creando…",
	},

	audit:
	{
		title_count:			"Registro de auditoría ({{total}})",
		filter_action_all:		"Todas las acciones",
		filter_actor:			"Actor (correo)…",
		filter_date_min:		"Fecha mín.",
		filter_date_max:		"Fecha máx.",
		no_entries:				"Sin entradas.",
		no_entries_filtered:	"Ninguna entrada coincide con los filtros.",
		col_when:				"Cuándo",
		col_action:				"Acción",
		col_actor:				"Actor",
		col_ip:					"IP",
		col_target:				"Objetivo",
		col_details:			"Detalles",
		actor_now_suffix:		"(ahora {{email}})",
		actor_deleted_suffix:	"(eliminado)",
		actor_deleted_tooltip:	"Cuenta eliminada",
	},

} as const;
